'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Dialog = require('@material-ui/core/Dialog');
var DialogContentText = require('@material-ui/core/DialogContentText');
var DialogContent = require('@material-ui/core/DialogContent');
var DialogActions = require('@material-ui/core/DialogActions');
var Button = require('@material-ui/core/Button');
var ClosableDialogTitle = require('../ClosableDialogTitle/ClosableDialogTitle.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Dialog__default = /*#__PURE__*/_interopDefaultLegacy(Dialog);
var DialogContentText__default = /*#__PURE__*/_interopDefaultLegacy(DialogContentText);
var DialogContent__default = /*#__PURE__*/_interopDefaultLegacy(DialogContent);
var DialogActions__default = /*#__PURE__*/_interopDefaultLegacy(DialogActions);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

var ConfirmationDialog = _ref => {
  var {
    isOpen,
    onClose,
    onConfirm,
    title = 'Discard Changes',
    message = '',
    cancelText = 'Cancel',
    confirmText = 'Yes, do it',
    children
  } = _ref;
  return /*#__PURE__*/React__default['default'].createElement(Dialog__default['default'], {
    fullWidth: true,
    maxWidth: "xs",
    open: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React__default['default'].createElement(ClosableDialogTitle.ClosableDialogTitle, {
    onClose: onClose
  }, title), Boolean(message) && /*#__PURE__*/React__default['default'].createElement(DialogContent__default['default'], null, Boolean(message) && /*#__PURE__*/React__default['default'].createElement(DialogContentText__default['default'], null, message)), children, /*#__PURE__*/React__default['default'].createElement(DialogActions__default['default'], null, /*#__PURE__*/React__default['default'].createElement(Button__default['default'], {
    onClick: onClose
  }, cancelText), /*#__PURE__*/React__default['default'].createElement(Button__default['default'], {
    onClick: onConfirm,
    color: "primary",
    variant: "contained"
  }, confirmText)));
};
ConfirmationDialog.propTypes = {
  isOpen: index.bool,
  onClose: index.func,
  onConfirm: index.func,
  title: index.string,
  message: index.string,
  cancelText: index.string,
  confirmText: index.string,
  children: index.node
};

exports.ConfirmationDialog = ConfirmationDialog;
exports.default = ConfirmationDialog;
